<template>
  <div class="outer-section Home">
    <h1>Dashboard</h1>
    <p>Um <code>Bücher</code>/<code>Artikel</code> zu bearbeiten, reicht es <code>authentifiziert</code> zu sein.
      Sobald ein Buch/Artikel aufgerufen wird, taucht ein zusätzlicher Button
      <code>bearbeiten</code> auf.</p>
    <p>Ein <code>Blogbeitrag</code> oder ein <code>Video</code> kann über die <code>Kategorieauswahl</code> in der <code>Artikelmaske</code> hinzugefügt werden.</p>
    <!-- <b-button
      block variant="outline-primary"
      :to="{ name: 'book-new' }">

      <i class="material-icons">book</i><span>&nbsp;Bücher verwalten</span>
    </b-button>
    <b-button
      block variant="outline-primary"
      :to="{ name: 'book-new' }">

      <i class="material-icons">ballot</i><span>&nbsp;Artikel verwalten</span>
    </b-button> -->
      <b-button
        variant="outline-primary"
        :to="{ name: 'variant-manager' }">

        <i class="material-icons">directions_car</i><span>&nbsp;Automodelle</span>
      </b-button>
      <b-button
        variant="outline-primary"
        :to="{ name: 'dk-product-manager' }">

        <i class="material-icons">layers</i><span>&nbsp;DK-Produkte</span>
      </b-button>
      <b-button
        variant="outline-success"
        :to="{ name: 'book-new' }">

        <i class="material-icons">add</i><span>&nbsp;Neues Buch</span>
      </b-button>
      <b-button
        variant="outline-success"
        :to="{ name: 'article-new' }">

        <i class="material-icons">add</i><span>&nbsp;Neuer Artikel</span>
      </b-button>
      <!-- <b-button
        block variant="outline-primary"
        :to="{ name: 'variant-manager' }">

        <i class="material-icons">video_library</i><span>&nbsp;Videos</span>
      </b-button> -->
      <br>
      <b-button @click="onLogoutClick">Abmelden</b-button>

  <router-view class="my-4"></router-view>
  </div>
  <!-- <div v-else class="outer-section Home">
    <h1 class="offset-md-3">Dashboard</h1>
    <p class="offset-md-3">Sie sind aktuell nicht <code>angemeldet</code>.
      Bitte <code>melden</code> sie sich zuerst <code>an</code>, um fortzufahren.</p>
    <RwvLogin @loggedIn="handleLoggedIn" />
  </div> -->
</template>

<script>
import RwvLogin from '@/views/Admin/Login.vue'
import { mapGetters } from "vuex";
import { LOGOUT } from "@/store/actions.type";

export default {
  title: "Dashboard | So wird's gemacht",
  name: 'Dashboard',
  components: {
    RwvLogin
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"])
  },
  methods: {
    onLogoutClick() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$bvToast.toast("Sie sind nun ausgeloggt", {
          title: "Erfolgreich abgemeldet!",
          variant: 'success'
        })
        this.$router.push({ name: "home" });
      });
    }
  }
}
</script>

<style lang="scss">
</style>
